// extracted by mini-css-extract-plugin
export default {"DescriptionBox":"DescriptionBox_DescriptionBox__KAN1F","desc":"DescriptionBox_desc__DgXDs","currency":"DescriptionBox_currency__bDqj3"};